module.exports = __webpack_public_path__ + "static/img/lisence.f96b6eb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/lisence.jpg
// module id = dvUE
// module chunks = 6